/**
 * WordPress dependencies.
 */
import { filter } from "lodash";
import { SnackbarList, NoticeList } from "@wordpress/components";
import { useSelect, useDispatch } from "@wordpress/data";
import { store as noticesStore } from "@wordpress/notices";

export const SnakeNotices = () => {
	const notices = useSelect((select) => select(noticesStore).getNotices(), []);

	const { removeNotice } = useDispatch(noticesStore);

	const snackbarNotices = filter(notices, {
		type: "snackbar",
	});

	if (snackbarNotices.length >= 1) {
		return (
			<SnackbarList
				notices={snackbarNotices}
				className="components-editor-notices__snackbar"
				onRemove={removeNotice}
			/>
		);
	}

	return "";
};

export const AdminNotices = () => {
	const notices = useSelect((select) => select(noticesStore).getNotices());

	const { removeNotice } = useDispatch(noticesStore);

	const defaultNotices = filter(notices, {
		type: "default",
	});

	if (defaultNotices.length >= 1) {
		return <NoticeList notices={defaultNotices} onRemove={removeNotice} />;
	}

	return "";
};
